/**
 * Supabase Client for Client-Side Authentication
 * 
 * Uses the anon key for client-side operations (auth only).
 * Server uses service role key for data operations.
 */

import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl: string = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey: string = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

let cachedClient: SupabaseClient | null = null;

/**
 * Get the Supabase client instance.
 * Returns null if Supabase is not configured.
 */
export const getSupabaseClient = (): SupabaseClient | null => {
  if (!supabaseUrl || !supabaseAnonKey) {
    return null;
  }

  if (cachedClient) {
    return cachedClient;
  }

  cachedClient = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
  });

  return cachedClient;
};

/**
 * Check if Supabase auth is available
 */
export const isAuthAvailable = (): boolean => {
  return !!supabaseUrl && !!supabaseAnonKey;
};
